import React, { memo } from 'react';
export function Solution() {
  return <section className="py-20 px-4 bg-white" data-id="element-187">
      <div className="max-w-3xl mx-auto text-center space-y-10" data-id="element-188">
        <div className="inline-block bg-teal-100 text-teal-700 font-bold px-6 py-2 rounded-full tracking-widest text-sm mb-4" data-id="element-189">
          LA SOLUCIÓN
        </div>

        <h2 className="text-5xl md:text-6xl font-extrabold text-slate-900 tracking-tight" data-id="element-190">
          MENTE ACTIVA™
        </h2>

        <h3 className="text-2xl md:text-3xl font-medium text-slate-700" data-id="element-191">
          El sistema completo de activación cognitiva para adultos mayores
        </h3>

        <div className="text-lg md:text-xl text-slate-700 space-y-6 leading-relaxed bg-[#EFE4CC] p-8 rounded-2xl border border-orange-200 text-left" data-id="element-192">
          <p className="font-semibold text-slate-900 text-center pb-4 border-b border-orange-200" data-id="element-193">
            Sin clínicas. Sin aplicaciones. Sin conocimientos técnicos previos.
          </p>
          <p data-id="element-194">
            Todo el sistema ya está diseñado, organizado y listo para usar desde
            el primer día. 48 fichas imprimibles que cualquier adulto mayor
            puede completar solo o en familia. Creado específicamente para la
            realidad argentina.
          </p>
          <p data-id="element-195">
            El Sistema de Activación Progresiva nació de entender algo que la
            mayoría ignora:{' '}
            <span className="text-teal-700 font-medium" data-id="element-196">
              la memoria no se pierde de golpe
            </span>
            . Se va apagando de a poco por falta de uso. Y se puede recuperar de
            a poco con el estímulo correcto en el momento correcto.
          </p>
          <blockquote className="border-l-4 border-teal-600 pl-6 py-2 italic text-slate-600 bg-white rounded-r-lg" data-id="element-197">
            "Diseñé este sistema porque en Argentina no existía nada concreto
            que una familia pudiera usar en casa sin ser profesional de la
            salud. Todo lo que está acá está pensado para que funcione en la
            mesa del comedor, no en una clínica."
          </blockquote>
        </div>
      </div>
    </section>;
}